
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/privacy-policy",
      function () {
        return require("private-next-pages/en/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/privacy-policy"])
      });
    }
  